<template>
  <tr>
    <template v-if="header">
      <td class="nosort">Account Name</td>
      <td class="nosort">Program Name</td>
      <td class="nosort">Year</td>
      <td class="violations nosort">Violations</td>
    </template>
    <template v-else-if="violation">
      <td class="account-name">
        <div class="account-name">
          <router-link
            :to="`/account/${violation.accountID}/policy-detail`"
            data-test="account-name"
            :title="violation.accountName"
          >
            {{ violation.accountName?.substring(0, 30) }}
          </router-link>
        </div>
      </td>
      <td class="program-name">{{ violation.programName }}</td>
      <td class="program-year">{{ violation.programYear }}</td>
      <td class="violations">
        <div class="rule-container tw:inline-flex" v-for="(rule, index) in violatedRules(violation)" :key="index">
          <v-tooltip location="bottom" v-if="rule.violated">
            <template v-slot:activator="{ props }">
              <span v-bind="props"
                    class="tw:flex tw:bg-primary tw:w-5 tw:h-5 tw:text-white tw:mr-0.5 tw:rounded-full tw:text-[10pt] tw:font-bold tw:justify-center tw:items-center tw:scale-[85%]">
                <span class="tw:w-fit tw:h-fit tw:font-mono">{{ rule.value }}
                </span>
              </span>
            </template>
            <h4>Rule</h4>
            <p>{{ rule.desc }}</p>
            <h4>Resolution</h4>
            <p>{{ rule.resolution }}</p>
          </v-tooltip>
        </div>
      </td>
    </template>
  </tr>
</template>

<script setup lang="ts">
import { DataQualityProgram, DataQualityRule } from '@/types/DataQuality';

const props = defineProps<{
  header?: boolean,
  violation?: DataQualityProgram,
  rules?: Readonly<DataQualityRule[]>,
}>();

function violatedRules(policy: DataQualityProgram) {
  if (!props.rules) return [];
  return props.rules.map((r, i) => ({ ...r, violated: Reflect.get(policy, 'rule' + (i + 1)) })) as (DataQualityRule & {
    violated: boolean
  })[];
}
</script>
